<p-table
  [value]="formArrayInput.controls"
  [columns]="displayColumns"
  [tableStyle]="{ width: '100%' }"
  scrollHeight="flex"
>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <!--非唯讀時多顯示一欄位(刪除)-->
      <th *ngIf="!readonly" style="width: 5rem"></th>
      <th *ngFor="let col of columns">{{ col.header | translate }}</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
    <tr [formGroup]="row">
      <td *ngIf="!readonly">
        <button
          *ngIf="(required && rowIndex !== 0) || !required"
          pButton
          icon="pi pi-delete"
          class="p-button-action p-button-outlined"
          (click)="removeRow(rowIndex)"
        ></button>
      </td>
      <td>
        <ng-container *ngIf="!readonly; else readonlyIdentityNo">
          <sigv-form-control-widget
            [bindingFormControl]="row?.controls.identityNo"
          >
            <input
              pInputText
              type="text"
              formControlName="identityNo"
              (blur)="onFieldChange(rowIndex)"
              class="form-control p-inputtext p-inputtext-cust"
              placeholder="{{ 'Please Enter' | translate }}"
            />
          </sigv-form-control-widget>
        </ng-container>
        <ng-template #readonlyIdentityNo>
          {{ row?.controls.identityNo.value || '-' }}
        </ng-template>
      </td>
      <td>
        <ng-container *ngIf="!readonly; else readonlyIdentificationType">
          <sigv-form-control-widget
            [bindingFormControl]="row?.controls.identificationType"
          >
            <p-dropdown
              formControlName="identificationType"
              appendTo="body"
              [options]="identificationTypeOptions"
              [disabled]="readonly"
              (onChange)="onFieldChange(rowIndex)"
              placeholder="{{ 'Please Select' | translate }}"
              [showClear]="true"
            ></p-dropdown> </sigv-form-control-widget
        ></ng-container>
        <ng-template #readonlyIdentificationType>
          {{
            row?.controls.identificationType.value
              | optionsMapping: identificationTypeOptions
          }}
        </ng-template>
      </td>
    </tr>
  </ng-template>
  <!--查無資料-->
  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="readonly ? 2 : 3" class="p-text-center p-no-data">
        {{ 'No Data' | translate }}
      </td>
    </tr>
  </ng-template>
</p-table>
<div class="p-text-left mt-20">
  <button
    pButton
    label="{{ 'Add' | translate }}"
    icon="pi pi-add-white"
    class="p-button-secondary p-content-button"
    (click)="addRow()"
    *ngIf="!readonly"
  ></button>
</div>
